import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Component({
	selector: 'ui-input-autocompleter',
	template: `
		<div class="mat-autocomplete-large">
			<mat-form-field>
				<input [formControl]="formControl"
					   (change)="changed()"
					   type="text" placeholder="{{text}}" aria-label="Number" matInput [matAutocomplete]="auto">

				<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autocompleteDisplay"
								  (closed)="closed()">
					<ng-container *ngIf="multiple; else singleItem">
					
					<mat-option *ngFor="let item of  autocomplete$ | async; let index=index" [value]="item" >
						<mat-checkbox   (change)="onOptionChange(item)"  (click)="$event.stopPropagation()" [checked]="isChecked(item.Id)">
						{{autocompleteDisplay(item)}}
						</mat-checkbox>
						</mat-option>
						</ng-container>
                  <ng-template #singleItem>
					<mat-option *ngFor="let item of  autocomplete$ | async; let index=index" [value]="item" >
																
						{{autocompleteDisplay(item)}}
						
					</mat-option>
					</ng-template>
				</mat-autocomplete>
			</mat-form-field>
		</div>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputAutocompleterComponent),
			multi: true
		}
	]
})
export class UIInputAutocompleterComponent extends CVA implements OnInit {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() text = 'Search';
	@Input() controller;
	@Input() autocompleteDisplay;
	@Input() presentationMode = false;
	@Input() searchObservable = () => {
	};
    @Input() multiple:boolean=false;
	@Output() valueChange=new EventEmitter<any>();
	@Input() userSelectedRoles:any[]=[];
	public closed() {
		if (typeof this.formControl.value !== 'object') {
			this.formControl.setValue('');
			this.formControl.reset('');
		}

	}

	public changed() {		
		if (typeof this.formControl.value !== 'object') {
			// this.formControl.setValue('');
			// this.formControl.reset('');
			
		}

	}

	public autocomplete$;
	public formControl = new FormControl();

	public ngOnInit() {
		this.autocomplete$ = this.formControl.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				//if (value !== '') {
				return this.aliases_lookup(value);
				/*} else {
					// if no value is present, return null
					return of(null);
				}*/
			}));

			
	}

	public aliases_lookup(value): Observable<any[]> {
		
		if (typeof value === 'string') {			
			return this.searchObservable.call(this.controller, value).pipe(
				// map the item property of the github results as our return object
				map(results => results)
			);
		} else {
			return new Observable<any[]>();
		}
	}

onOptionChange(item:any){
	if(this.multiple){		
		this.valueChange.emit(item);
		console.log( "autocomplete",this.autocomplete$);
	}
}

isChecked(Id:number):boolean{
  
	return this.userSelectedRoles.some(x=>x.Id===Id);
}

}
